<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="chat-icon"
    >
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
    </svg>
</template>

<script>
export default {
    name: "ChatIcon",
};
</script>

<style scoped>
.chat-icon {
    width: 100%;
    height: 100%;
    color: #8796af;
}
</style>
